import { Typography } from 'antd';
import type { TFunction } from 'i18next';
import { ColoredTag } from './tags';
import {
  ACCOUNT_TYPE_LABEL_KEYS,
  AccountType,
  resolveAccountType,
} from './types';

const { Text } = Typography;

type AccountTypeTagProps = {
  accountTypeKey: string | undefined;
  t: TFunction;
};

const ACCOUNT_TYPE_TAG_STYLES: Partial<
  Record<
    string,
    {
      bgcolor: string;
      color: string;
    }
  >
> = {
  [AccountType.OWNER]: {
    bgcolor: 'var(--account-type-owner-bg, #fbe3ff)',
    color: 'var(--account-type-owner-text, #042a2a)',
  },
  [AccountType.CLIENT]: {
    bgcolor: 'var(--account-type-client-bg, #ccf5fe)',
    color: 'var(--account-type-client-text, #042a2a)',
  },
  [AccountType.STAFF]: {
    bgcolor: 'var(--account-type-staff-bg, #f9eec7)',
    color: 'var(--account-type-staff-text, #042a2a)',
  },
};

export const AccountTypeTag = ({ accountTypeKey, t }: AccountTypeTagProps) => {
  if (!accountTypeKey) {
    return (
      <Text style={{ fontSize: '14px', color: 'var(--color-text-base, #2e2e2e)' }}>
        -
      </Text>
    );
  }

  const translationKey = ACCOUNT_TYPE_LABEL_KEYS[accountTypeKey];
  const label = translationKey
    ? t(translationKey)
    : resolveAccountType(accountTypeKey) || accountTypeKey;
  const accountType = resolveAccountType(accountTypeKey);
  const tagStyle = accountType ? ACCOUNT_TYPE_TAG_STYLES[accountType] : undefined;

  if (tagStyle) {
    return (
      <ColoredTag
        className={`scope-account-type-tag scope-account-type-tag--${String(accountType).toLowerCase()}`}
        bgcolor={tagStyle.bgcolor}
        color={tagStyle.color}
      >
        {label}
      </ColoredTag>
    );
  }

  return (
    <Text style={{ fontSize: '14px', color: 'var(--color-text-base, #2e2e2e)' }}>
      {label || '-'}
    </Text>
  );
};
